var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yt-student-list"},[(_vm.stateFilterBySchool)?_c('GridTable',{key:_vm.componentKey,ref:"gridTable",attrs:{"id":"StudentList","title":("" + _vm.title + (_vm.appendTitle || '')),"urlPath":"studentsCms","columns":_vm.columns,"schema":_vm.schema,"supportAddNew":false,"hasEditItem":false,"hasDeleteItem":true,"defaultServerParams":{
      _fields:
        '_id,firstName,lastName,school._id,school.name,code,user.isActive,grade._id,grade.name,createdAt,learningMinutes,' +
        'tutor._id,tutor.isActive,tutor.subjects,tutor.teachingMinutes',
      schoolId: _vm.filteredBySchool,
      isDeleted: false,
      _sort: 'createdAt',
      _order: 'desc'
    }},scopedSlots:_vm._u([{key:"customButtons",fn:function(slotProps){return [_c('router-link',{staticClass:"btn btn-success",attrs:{"to":{
          name: 'StudentDetail',
          params: { id: slotProps.props.row._id }
        }}},[_vm._v("View")])]}}],null,false,2527068360)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c45839e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/students/StudentList.vue
// module id = null
// module chunks = 